
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "Corpus_uteri_tumor",
components: {
XTable
}
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Onco/Corpus_uteri_tumor.vue